"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;

var _pubSub = require("@ictoanen/pub-sub");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* ========================================================================== */
function getUniqueContainerId() {
  if (!getUniqueContainerId.num) {
    getUniqueContainerId.num = 0;
  }

  getUniqueContainerId.num += 1;
  return "container-".concat(getUniqueContainerId.num.toString());
}
/* ========================================================================== */


var Container = /*#__PURE__*/function () {
  function Container() {
    var _this = this;

    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$state = _ref.state,
        _state = _ref$state === void 0 ? {} : _ref$state,
        _ref$transforms = _ref.transforms,
        transforms = _ref$transforms === void 0 ? [] : _ref$transforms;

    _classCallCheck(this, Container);

    _defineProperty(this, "events", {
      update: "UPDATE",
      beforeUpdate: "BEFORE_UPDATE"
    });

    _defineProperty(this, "transformState", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(updatedState, state, options) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", _this.transforms.reduce( /*#__PURE__*/function () {
                  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(currentState, transform) {
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.prev = 0;
                            _context.t0 = _objectSpread;
                            _context.t1 = {};
                            _context.next = 5;
                            return currentState;

                          case 5:
                            _context.t2 = _context.sent;
                            _context.t3 = {};
                            _context.t4 = transform;
                            _context.next = 10;
                            return currentState;

                          case 10:
                            _context.t5 = _context.sent;
                            _context.t6 = updatedState;
                            _context.t7 = options;
                            _context.t8 = {
                              currentState: _context.t5,
                              updatedState: _context.t6,
                              options: _context.t7
                            };
                            _context.next = 16;
                            return (0, _context.t4)(_context.t8);

                          case 16:
                            _context.t9 = _context.sent;
                            return _context.abrupt("return", (0, _context.t0)(_context.t1, _context.t2, _context.t3, _context.t9));

                          case 20:
                            _context.prev = 20;
                            _context.t10 = _context["catch"](0);
                            throw new Error(_context.t10);

                          case 23:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, null, [[0, 20]]);
                  }));

                  return function (_x4, _x5) {
                    return _ref3.apply(this, arguments);
                  };
                }(), state));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x, _x2, _x3) {
        return _ref2.apply(this, arguments);
      };
    }());

    _defineProperty(this, "update", /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(updatedState) {
        var options,
            _args3 = arguments;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                options = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
                (0, _pubSub.publish)(_this.events.beforeUpdate, {
                  updatedState: updatedState
                }, _this.eventScope);
                _context3.next = 4;
                return _this.transformState(updatedState, _objectSpread({}, _this.state, {}, updatedState), options);

              case 4:
                _this.state = _context3.sent;
                (0, _pubSub.publish)(_this.events.update, {
                  updatedState: updatedState
                }, _this.eventScope);
                return _context3.abrupt("return", _this.state);

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x6) {
        return _ref4.apply(this, arguments);
      };
    }());

    _defineProperty(this, "delete", /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(property) {
        var options,
            _args4 = arguments;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                options = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : {};

                if (property in _this.state) {
                  _context4.next = 3;
                  break;
                }

                throw new ReferenceError("Cannot delete property ".concat(property, " from state. State is currently: ").concat(JSON.stringify(_this.state)));

              case 3:
                (0, _pubSub.publish)(_this.events.beforeUpdate, {}, _this.eventScope);
                delete _this.state[property];
                _context4.next = 7;
                return _this.transformState({}, _this.state, options);

              case 7:
                _this.state = _context4.sent;
                (0, _pubSub.publish)(_this.events.update, {}, _this.eventScope);
                return _context4.abrupt("return", _this.state);

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x7) {
        return _ref5.apply(this, arguments);
      };
    }());

    this.state = _state;
    this.transforms = transforms;
    this.eventScope = {
      scope: getUniqueContainerId()
    };
  }
  /* ======================================================================== */

  /**
   * There are currently only two events, one before the update chain is run,
   * and one once its done updated and we have our new state.
   */


  _createClass(Container, [{
    key: "subscribeToEvent",

    /* ======================================================================== */
    value: function subscribeToEvent(event, callback) {
      var _this2 = this;

      (0, _pubSub.subscribe)(event, function (_ref6) {
        var detail = _ref6.detail;
        return callback(_objectSpread({}, detail, {
          currentState: _this2.state
        }));
      }, this.eventScope);
    }
    /* ======================================================================== */

  }, {
    key: "onUpdate",
    value: function onUpdate(callback) {
      this.subscribeToEvent(this.events.update, callback);
    }
  }, {
    key: "onBeforeUpdate",
    value: function onBeforeUpdate(callback) {
      this.subscribeToEvent(this.events.beforeUpdate, callback);
    }
    /* ======================================================================== */

  }]);

  return Container;
}();

exports.Container = Container;